import React, { useContext, useEffect, useState } from 'react';
import { Content, ContentHeader, PageWithHeader } from '@backstage/core-components';
import { Progress } from '@backstage/core-components';
import { Box, Typography } from '@material-ui/core';
import { AlertSnackbar, AppContext } from '@softwareone/plugin-project-management-react';

export function ConfluencePermissionsPage() {
  const {
    services: { confluenceService },
  } = useContext(AppContext);

  const [permissions, setPermissions] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        setLoading(true);
        const data = await confluenceService.getUnexpectedPermissions();
        setPermissions(data);
      } catch (err) {
        const message = err instanceof Error ? err.message : 'Failed to fetch Confluence permissions';
        setError(message);
      } finally {
        setLoading(false);
      }
    };
    fetchPermissions();
  }, [confluenceService]);

  const handleClose = () => {
    setError(null);
  };

  return (
    <PageWithHeader title="Confluence Permissions" themeId="home">
      <Content>
        <ContentHeader title="Permissions" />
        {loading && <Progress />}
        {!loading && permissions && (
          <Box sx={{ mt: 2 }}>
            <Typography
              component="pre"
              style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '0.875rem' }}
            >
              {JSON.stringify(permissions, null, 2)}
            </Typography>
          </Box>
        )}
        {!loading && !permissions && !error && <Typography>No permissions data available.</Typography>}
        <AlertSnackbar open={!!error} onClose={handleClose} severity="error" message={error ?? ''} />
      </Content>
    </PageWithHeader>
  );
}
